var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "870.3px",
    height: "870.3px",
    viewBox: "0 0 870.3 870.3",
    style: {
      enableBackground: "new 0 0 870.3 870.3"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M561.05,288.9c27.898,11.8,53.699,27.3,77.1,46.2V201.5c0-111.1-90.4-201.5-201.5-201.5h-3.1 c-111,0-201.4,90.4-201.4,201.5v133.6c23.4-18.899,49.2-34.399,77.1-46.2c7.5-3.2,15.2-6.1,22.9-8.7v-78.7 c0-56,45.5-101.5,101.5-101.5h3.1c56,0,101.5,45.5,101.5,101.5v78.8C545.849,282.8,553.55,285.7,561.05,288.9z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.75,586.9c0,156.5,126.9,283.399,283.4,283.399c156.5,0,283.401-126.8,283.401-283.399 c0-76.9-30.701-146.7-80.4-197.801c-28-28.699-62-51.5-100-66.399c-31.9-12.5-66.701-19.3-103-19.3c-36.3,0-71.1,6.8-103,19.3 c-38,14.8-72,37.6-100,66.399C182.35,440.2,151.75,510,151.75,586.9z M362.149,529.7c1-38.7,32.5-70.2,71.2-71.101 c41.099-1,74.8,32.101,74.8,73c0,4.301-0.4,8.5-1.1,12.5c-3.602,20.7-15.9,38.5-33.102,49.301c-7.1,4.5-10.699,12.899-8.898,21 L486.75,717.3c1.301,6.2-3.4,12.101-9.801,12.101H393.35c-6.4,0-11.101-5.801-9.8-12.101L405.249,614.4 c1.7-8.2-1.8-16.601-8.899-21.101c-17.2-10.8-29.5-28.5-33.101-49.3C362.449,539.4,362.05,534.6,362.149,529.7z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLock);
export default __webpack_public_path__ + "static/media/Lock.f1b29eed.svg";
export { ForwardRef as ReactComponent };